import { SB } from '@play-co/replicant';
import promoGroupSchema from './group/promoGroup.schema';

export default {
  promo: SB.map(
    SB.object({
      // Last time promo was shown
      shownAt: SB.int(),
      // If false - stop showing promo
      active: SB.boolean(),
      // How many times was shown
      count: SB.int(),
      // If rewards were claimed
      claimedRewards: SB.boolean().default(false),
    }),
  ),
  ...promoGroupSchema,
};
